import { Outlet } from "react-router";
import { motion } from "framer-motion";
import { useBreakpoint } from "@reactive-resume/hooks";
import { cn } from "@reactive-resume/utils";

import { AdminHeader } from "./_components/header";
import { Sidebar } from "./_components/sidebar";

export const DashboardLayoutAdm = () => {
  const { isDesktop } = useBreakpoint();

  return (
    <div className="min-h-screen bg-admin-background">
      <div className="lg:hidden">
        <AdminHeader />
      </div>

      {/* Sidebar Desktop (Fixe à gauche) */}
      <motion.div
        initial={{ x: -280 }}
        animate={{ x: 0 }}
        className="hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-50 lg:flex lg:w-[260px] lg:flex-col"
      >
        <div className="h-full border-r border-admin-border bg-admin-surface">
          <Sidebar />
        </div>
      </motion.div>

      {/* Contenu Principal (Responsive) */}
      <main
        className={cn(
          "relative min-h-screen bg-admin-background py-4 transition-all duration-300",
          isDesktop ? "lg:pl-[284px] lg:pr-6" : "px-6",
        )}
      >
        <Outlet />
      </main>
    </div>
  );
};
